import React from "react";
import { Flex, Stack, Heading, Text, Box, HStack, Button, FormControl, FormLabel, Input, useToast } from "@chakra-ui/react";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import CustomFormInput from "../components/FormInputFields";
import CommonVars from "../components/CommonVars";
import axios from "axios";

function AddCategoryScreen() {
    if (localStorage.getItem('token') === null || JSON.parse(localStorage.getItem('userDetails')).role !== "admin") {
        window.location.replace("/unauthorized");
    }
    const theToken = localStorage.getItem('token');

    // set add category toast 
    const addCatToast = useToast();
    const id = 'addCat-toast';

    return (
        <Formik
            initialValues={{
                categoryname: ''
            }}
            validationSchema={Yup.object({
                categoryname: Yup.string()
                .min(4, 'Category name must be at least 4 characters long')
                .required('Category name is required'),
            })}
            onSubmit={(values, { setSubmitting, resetForm }) => {
                const categoryname = String(values.categoryname);
                // form data for image uploading
                const formData = new FormData();
                const file = document.getElementById('catImg').files[0];
                formData.append('image', file);

                // access backend endpoint to upload the category image
                axios.post(`${CommonVars.API_URL}/upload-catImg`, formData, { headers: { Authorization: `Bearer ${theToken}` } })
                .then((res) => {
                    console.log(res.data);
                    const uploadedCatImg = res.data;
                    // prepare the add category request body
                    const addCatRequestBody = {
                        categoryname,
                        category_img_url: uploadedCatImg,
                    }
                    // access backend endpoint to post a new category
                    return axios.post(
                        `${CommonVars.API_URL}/category`, 
                        addCatRequestBody,
                        { headers: { Authorization: `Bearer ${theToken}` } }
                    )
                    .then(() => {
                        setSubmitting(false);
                        if(!addCatToast.isActive(id)) {
                            addCatToast({
                                id,
                                title: 'New Category Added!',
                                description: "New category is added successfully!",
                                status: 'success',
                                position: 'top',
                                duration: 2000,
                                isClosable: true,
                            });
                        }
                        resetForm();
                    })
                    .catch((error) => {
                        if(!addCatToast.isActive(id)) {
                            addCatToast({
                                id,
                                title: 'Adding Failed.',
                                description: "Something went wrong with adding...",
                                status: 'error',
                                position: 'top',
                                duration: 2000,
                                isClosable: true,
                            });
                        }
                        console.log(error);
                    })
                })
                .catch((error) => {
                    console.log(error);
                })
            }}
        >
            {props => (
                <Flex
                    bg={'#F4F4F4F4'}
                    align={'center'}
                    justify={'center'}
                    minH={'100vh'}
                >
                    <Stack spacing={8} mx={'auto'} maxW={'lg'} py={12} px={6}>
                        <Stack align={'center'}>
                            <Heading fontSize={'4xl'}>Add a New Category</Heading>
                            <Text fontSize={'lg'} color={'gray.600'}>
                                Expand the variety of the website with a new category!
                            </Text>
                        </Stack>
                        <Box
                            rounded={'lg'}
                            bg={'white'}
                            boxShadow={'lg'}
                            p={8}
                        >
                            <Form>
                                <Stack spacing={4}>
                                    {/* Category Name input */}
                                    <CustomFormInput 
                                        label="Category Name"
                                        name="categoryname"
                                        type="text"
                                        placeholder="Enter Category Name"
                                    />
                                    {/* Category Image Input */}
                                    <FormControl>
                                        <FormLabel>Category Image</FormLabel>
                                        <Input id="catImg" type={'file'} size='md' variant={'flushed'} required/>
                                    </FormControl>
                                    {/* Form Buttons */}
                                    <HStack spacing='20px' pt={2} pb={1}>
                                        <Button type='submit' bg={'black'} color={'white'} _hover={{bg: '#37404A',}}>{props.isSubmitting ? 'Loading...' : 'Add Category'}</Button>
                                        <Button type='reset'>Reset</Button>
                                    </HStack>
                                </Stack>
                            </Form>
                        </Box>
                    </Stack>
                </Flex>
            )}
        </Formik>
    )
}

export default AddCategoryScreen;
